export default __webpack_public_path__ + "22555b55def970341edff4aece6671fa.gif";